import React from "react";

// Processed logo with transparent background (served statically from /public)
const LOGO_URL = "/logo.png";

export const Logo = ({ size = "default", className = "", onDark = false }) => {
  const heights = {
    small: "h-9",
    default: "h-12",
    large: "h-20",
    xlarge: "h-28",
  };
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="ala-logo">
      <img
        src={LOGO_URL}
        alt="ALA Graphics"
        className={`${heights[size] || heights.default} w-auto select-none ${onDark ? "drop-shadow-[0_0_12px_rgba(255,255,255,0.25)]" : ""}`}
        draggable={false}
      />
    </div>
  );
};

export default Logo;
